import * as ExpenseCalculators from 'app/calcs/expenses'
import { RadioGroup } from 'app/components';
import { RetirementAgeSelector } from 'app/components/form/RetirementAgeSelector'
import MaterialNumber from 'app/components/material/MaterialNumber'
import PlainInput from 'app/components/PlainInput'
import { IQuestionsGroupContainerProps, QuestionsGroupContainer } from 'app/containers/PipelineSection/QuestionGroupContainer'
import { IExpenses, missingPeopleProperties, Profile } from 'app/redux/Profile/model'
import { isGoodDuration } from 'app/utils'
import * as _ from 'lodash'
import * as moment from 'moment'
import * as React from 'react'
import { Button } from 'react-bootstrap'

type Options = 'full' | 'easy'

interface IExpensesIntroContainerState {
  profile: Profile
  haveEnoughDataForChart: boolean
  estimatedMonthlyExpenses: string
  estimatedMonthlyExpensesPostSwitchover: string
  expenseSwitchoverMemberAge: moment.Duration
  useEstimatedExpenses: boolean
  missingRetirementAgeInfos: any[]
  selectedOptions: Options[]
}

const defaultSwitchoverAge = moment.duration(65, 'years')

class ExpensesIntroContainer extends QuestionsGroupContainer<IQuestionsGroupContainerProps, IExpensesIntroContainerState> {
  estimatedMonthlyExpensesNS = 'expenses.estimatedMonthlyExpenses'
  estimatedMonthlyExpensesPostSwitchoverNS = 'expenses.estimatedMonthlyExpensesPostSwitchover'
  goo: Options = 'full'

  state = {
    profile: null,
    haveEnoughDataForChart: false,
    estimatedMonthlyExpenses: '0',
    estimatedMonthlyExpensesPostSwitchover: '0',
    expenseSwitchoverMemberAge: null,
    useEstimatedExpenses: false,
    missingRetirementAgeInfos: [],
    selectedOptions: [this.goo]
  }

  componentWillMount() {
    this.onAppStateUpdate((appState) => {
      const profile = appState.Profile.getNative('info') || null
      if (!profile) { return }

      if (!profile.expenses) {
        const ex = {} as any as IExpenses
        profile.expenses = ex
      }

      if (profile.expenses && !_.isArray(profile.expenses.auto)) {
        profile.expenses.auto = []
      }

      const expenseSwitchoverMemberAge = profile.expenses ? profile.expenses.expenseSwitchoverMemberAge : defaultSwitchoverAge

      if (profile.expenses && profile.expenses.estimatedMonthlyExpenses) {
        const estimatedMonthlyExpenses = profile.expenses.estimatedMonthlyExpenses.toLocaleString()
        const estimatedMonthlyExpensesPostSwitchover = profile.expenses.estimatedMonthlyExpensesPostSwitchover.toLocaleString()
        // tslint:disable-next-line:no-debugger
        //debugger
        const useEstimatedExpenses = true
        this.goo = this.state.estimatedMonthlyExpenses ? 'easy' : 'full'
        const selectedOptions = [this.goo]
        this.setState({ selectedOptions, estimatedMonthlyExpenses, estimatedMonthlyExpensesPostSwitchover, useEstimatedExpenses })
      }

      // generate the chart if we have enough information for that
      const people = profile.getImportantPeople()
      const haveEnoughDataForChart = ExpenseCalculators.haveEnoughDataForExpensesCalculation(people) && isGoodDuration(profile.expenses.expenseSwitchoverMemberAge)
      const missingRetirementAgeInfos = missingPeopleProperties(people, ExpenseCalculators.neededPropertiesForExpenses)
      // tslint:disable-next-line:no-console
      //console.log('missingRetirementAgeInfos is ' + JSON.stringify(missingRetirementAgeInfos))

      this.setState({ profile, expenseSwitchoverMemberAge, haveEnoughDataForChart, missingRetirementAgeInfos })
    })
  }

  update<K extends keyof IExpensesIntroContainerState>(key: K, value: IExpensesIntroContainerState[K]) {
    const newState = { ...this.state }
    newState[key] = value
    // tslint:disable-next-line:no-console
    console.log('expense update: ' + key + ' => ' + value)

    this.setState(newState)
  }

  updateEstimatedExpensesSwitchoverAge(expenseSwitchoverMemberAge: moment.Duration) {
    this.state.profile.expenses.expenseSwitchoverMemberAge = expenseSwitchoverMemberAge
    this.setState({ expenseSwitchoverMemberAge })

    this.markSignificantProfileUpdate(this.state.profile)
  }

  updateExpenses(e: React.ChangeEvent<HTMLInputElement>) {
    const estimatedMonthlyExpenses = e.currentTarget.value
    this.update('estimatedMonthlyExpenses', estimatedMonthlyExpenses)
  }

  updateEstimatedMonthlyExpensesPostSwitchover(e: React.ChangeEvent<HTMLInputElement>) {
    const estimatedMonthlyExpensesPostSwitchover = e.currentTarget.value
    this.update('estimatedMonthlyExpensesPostSwitchover', estimatedMonthlyExpensesPostSwitchover)
  }

  useEstimatedMonthlyExpenses(useEstimatedExpenses: boolean) {
    const estimatedMonthlyExpenses = useEstimatedExpenses ? this.state.estimatedMonthlyExpenses : null
    const estimatedMonthlyExpensesPostSwitchover = useEstimatedExpenses ? this.state.estimatedMonthlyExpensesPostSwitchover : null
    this.setState({ useEstimatedExpenses, estimatedMonthlyExpenses, estimatedMonthlyExpensesPostSwitchover })
  }

  toggleUseEstimatedExpenses() {
    this.useEstimatedMonthlyExpenses(!this.state.useEstimatedExpenses)
  }

  render() {

    const member = this.state.profile.getHeadOfHousehold()
    const switchoverAgePlaceholder = 'How old will ' + member.firstName + ' be when the expenses change?'
    const missingRetirementAgeText = _.map(this.state.missingRetirementAgeInfos, (info) => info.who.firstName).join(' and ')
    const opts = [
      {
        label: 'Walk through section to consider various expenses individually',
        value: 'full'
      },
      {
        label: <span className="useEstimatedExpenses">
          Use estimated monthly expenses of&nbsp;
          <PlainInput className="estimatedAmount"
            formattedNumberMode
            disabled={!this.state.useEstimatedExpenses}
            name={this.estimatedMonthlyExpensesNS}
            value={this.state.estimatedMonthlyExpenses}
            onChange={(e) => this.updateExpenses(e)}
          />
          &nbsp;&nbsp;After the age above, use expenses of&nbsp;
              <PlainInput className="estimatedAmount"
            formattedNumberMode
            name={this.estimatedMonthlyExpensesPostSwitchoverNS}
            value={this.state.estimatedMonthlyExpensesPostSwitchover}
            onChange={(e) => this.updateEstimatedMonthlyExpensesPostSwitchover(e)}
          />
        </span>,
        value: 'easy'
      }
    ]

    return (
      <section>
        <h1>Calculate Expenses</h1>
        <section>
          <h5 className="lead">In this section, you'll be entering your current expenses and the expenses you expect to have once you retire in some general categories such as home, car, food etc... By the way, we’ll keep track of it all, and give you a summary of your selections in the end. </h5>
          <h5 className="lead">Your (family, if married) expenses might change over the course of your retirement, and the Calculator can reflect that.</h5>
          <RetirementAgeSelector min={55} max={70}
            required
            placeholder={switchoverAgePlaceholder}
            selectedValue={this.state.expenseSwitchoverMemberAge} onChange={(a) => this.updateEstimatedExpensesSwitchoverAge(a)}
          />
          <h5>How do you want to enter your expenses?</h5>
          <div>
            <RadioGroup
              name="bert"
              selectedValue={this.state.selectedOptions}
              onChange={(v: Options) => {
                // tslint:disable-next-line:no-console
                console.log('v: ' + JSON.stringify(v))
                const useEstimatedExpenses = v === 'easy'
                this.useEstimatedMonthlyExpenses(useEstimatedExpenses)
              }}
              options={opts}
            >
            </RadioGroup>
          </div>
          <br /><br />
          {this.state.useEstimatedExpenses ?
            <Button bsStyle="primary" bsSize="lg"
              disabled={!this.state.haveEnoughDataForChart}
              onClick={() => this.relocate('#/results', {})}>
              Next
              </Button> :
            <Button type="submit" bsStyle="primary" bsSize="lg"
              disabled={!this.state.haveEnoughDataForChart}>
              Get Started
              </Button>
          }
        </section>
      </section>
    )
  }
}

const ExpensesIntro = () => (
  <ExpensesIntroContainer
    header="Expenses Intro" icon="" />
)

export {
  ExpensesIntro
}



// WEBPACK FOOTER //
// ./src/app/containers/PipelineSection/Expenses/Introduction/index.tsx